import { isPersistedEntity, logger } from '@tunasong/models'
import type { Entity, EntityOrElement, Persisted } from '@tunasong/schemas'

/** graph-lib's moveEntity: moves and shows the failure alert itself; resolves true when the move happened */
export type MoveEntity = (args: { entity: Persisted<Entity>; newParent: Persisted<Entity> }) => Promise<boolean>

/**
 * Drop `item` on the card `target`: move it under the target through graph-lib's moveEntity, which awaits the move
 * and says when it did not happen ("Couldn't move …"). It used to dispatch addChild and drop the result, so a
 * failed move said nothing (GH #2549). Resolves true when the move happened.
 */
export const dropOnCard = async (
  item: EntityOrElement | undefined,
  target: Persisted<Entity>,
  moveEntity: MoveEntity
) => {
  if (!isPersistedEntity(item)) {
    logger.warn('Card drop: the dragged item is not a saved entity', { id: item?.id, target: target.id })
    return false
  }
  if (item.id === target.id) {
    return false
  }
  return moveEntity({ entity: item, newParent: target })
}
